import {
  USER_LOGIN_REQUESTED,
  USER_LOGIN_SUCCESSFUL,
  USER_LOGIN_FAILED,
  USER_REGISTRATION_REQUESTED,
  USER_REGISTRATION_SUCCESSFUL,
  USER_REGISTRATION_FAILED,
  USER_FORGOT_PASSWORD_REQUESTED,
  USER_FORGOT_PASSWORD_SUCCESSFUL,
  USER_FORGOT_PASSWORD_FAILED,
  USER_RESET_PASSWORD_REQUESTED,
  USER_RESET_PASSWORD_SUCCESSFUL,
  USER_RESET_PASSWORD_FAILED,
  USER_LOGOUT_REQUESTED,
  SET_AUTH_ERROR,
  TOGGLE_AUTH_MODAL,
  UNTOGGLE_AUTH_MODAL,
  USER_RESEND_EMAIL_REQUESTED,
  USER_RESEND_EMAIL_SUCCESSFUL,
  USER_RESEND_EMAIL_FAILED,
  USER_CHANGE_PASSWORD_REQUESTED,
  USER_CHANGE_PASSWORD_SUCCESSFUL,
  USER_CHANGE_PASSWORD_FAILED,
  SIGN_IN_FACEBOOOK_REQUEST,
  SIGN_IN_FACEBOOOK_SUCCESS,
  SIGN_IN_FACEBOOOK_FAILED,
  SIGN_UP_FACEBOOOK_REQUEST,
  SIGN_UP_FACEBOOOK_SUCCESS,
  SIGN_UP_FACEBOOOK_FAILED,
  SIGN_IN_GOOGLE_REQUEST,
  SIGN_IN_GOOGLE_SUCCESS,
  SIGN_IN_GOOGLE_FAILED,
  SIGN_UP_GOOGLE_REQUEST,
  SIGN_UP_GOOGLE_SUCCESS,
  SIGN_UP_GOOGLE_FAILED,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAILED,
  GET_TOKEN_PROFILE_REQUESTED,
  GET_TOKEN_PROFILE_SUCCESS,
  GET_TOKEN_PROFILE_FAILED,
  LOGIN_WALLET_ADDRESS_REQUESTED,
  LOGIN_WALLET_ADDRESS_SUCCESSFUL,
  LOGIN_WALLET_ADDRESS_FAILED,
} from "./action-types"

export const loginUser = (data) => {
  return {
    types: [USER_LOGIN_REQUESTED, USER_LOGIN_SUCCESSFUL, USER_LOGIN_FAILED],
    payload: {
      request: {
        method: "POST",
        url: `/api-token-auth/`,
        auth: false,
        data,
      },
    },
  }
}

export const getTokenProfile = () => {
  return {
    types: [
      GET_TOKEN_PROFILE_REQUESTED,
      GET_TOKEN_PROFILE_SUCCESS,
      GET_TOKEN_PROFILE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/account/profile/`,
      },
    },
  }
}

export const registerUser = (data) => {
  return {
    types: [
      USER_REGISTRATION_REQUESTED,
      USER_REGISTRATION_SUCCESSFUL,
      USER_REGISTRATION_FAILED,
    ],
    payload: {
      request: {
        method: "POST",
        url: `/student/register/`,
        auth: false,
        data,
      },
    },
  }
}

export const forgotPassword = (data) => {
  return {
    types: [
      USER_FORGOT_PASSWORD_REQUESTED,
      USER_FORGOT_PASSWORD_SUCCESSFUL,
      USER_FORGOT_PASSWORD_FAILED,
    ],
    payload: {
      request: {
        method: "POST",
        url: `/account/forgot-password/`,
        auth: false,
        data,
      },
    },
  }
}

export const resetPassword = (data) => {
  return {
    types: [
      USER_RESET_PASSWORD_REQUESTED,
      USER_RESET_PASSWORD_SUCCESSFUL,
      USER_RESET_PASSWORD_FAILED,
    ],
    payload: {
      request: {
        method: "POST",
        url: `/account/reset-password/`,
        auth: false,
        data,
      },
    },
  }
}

export const logoutUser = () => {
  return {
    types: [USER_LOGOUT_REQUESTED, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAILED],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/logout/`,
      },
    },
  }
}

export const resendEmail = (data) => {
  return {
    types: [
      USER_RESEND_EMAIL_REQUESTED,
      USER_RESEND_EMAIL_SUCCESSFUL,
      USER_RESEND_EMAIL_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/account/resend-email/`,
        data,
      },
    },
  }
}

export const changePassword = (data) => {
  return {
    types: [
      USER_CHANGE_PASSWORD_REQUESTED,
      USER_CHANGE_PASSWORD_SUCCESSFUL,
      USER_CHANGE_PASSWORD_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "PUT",
        url: `/account/change-password/`,
        data,
      },
    },
  }
}

export const setAuthError = (payload) => {
  return {
    type: SET_AUTH_ERROR,
    payload,
  }
}

export const showAuthModal = (payload) => {
  return {
    type: TOGGLE_AUTH_MODAL,
    payload,
  }
}

export const closeAuthModal = (payload) => {
  return {
    type: UNTOGGLE_AUTH_MODAL,
    payload,
  }
}

export const loginFacebook = (data) => {
  return {
    types: [
      SIGN_IN_FACEBOOOK_REQUEST,
      SIGN_IN_FACEBOOOK_SUCCESS,
      SIGN_IN_FACEBOOOK_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "POST",
        url: `/account/login/facebook/`,
        data,
      },
    },
  }
}

export const signUpFacebook = (data) => {
  return {
    types: [
      SIGN_UP_FACEBOOOK_REQUEST,
      SIGN_UP_FACEBOOOK_SUCCESS,
      SIGN_UP_FACEBOOOK_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "POST",
        url: `/account/signup/facebook/`,
        data,
      },
    },
  }
}

export const loginGoogle = (data) => {
  return {
    types: [
      SIGN_IN_GOOGLE_REQUEST,
      SIGN_IN_GOOGLE_SUCCESS,
      SIGN_IN_GOOGLE_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "POST",
        url: `/account/login/google/`,
        data,
      },
    },
  }
}

export const signUpGoogle = (data) => {
  return {
    types: [
      SIGN_UP_GOOGLE_REQUEST,
      SIGN_UP_GOOGLE_SUCCESS,
      SIGN_UP_GOOGLE_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "POST",
        url: `/account/signup/google/`,
        data,
      },
    },
  }
}

export const loginWalletAddress = (data) => {
  return {
    types: [
      LOGIN_WALLET_ADDRESS_REQUESTED,
      LOGIN_WALLET_ADDRESS_SUCCESSFUL,
      LOGIN_WALLET_ADDRESS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/users/wallet/login/`,
        data,
      },
    },
  }
}
